module.exports = __webpack_public_path__ + "media/images/unite3-7e1729703ebeef25de6761f2203eefca.png";